import { EventData } from '../models/manager-content-vehicle-history-drawer.model';

export interface PopupEvent {
  id: string;
  latitude: number;
  longitude: number;
  altitude?: number;
  speed?: number;
  direction?: number;
  date?: Date;
  reference?: string;
  nameEvent: string;
  isEvaluated: boolean;
  nameDriver: string;
}

let popupIdCounter = 0;

export const createPopupEvent = (
  coords: PopupEvent,
  eventIndex: number = 1
) => {
  popupIdCounter++;
  const id = `popup-event-${popupIdCounter}`;
  const urlGoogleMaps = `https://www.google.com/maps/search/?api=1&query=${coords.latitude},${coords.longitude}`;
  const longitude = coords.longitude ? `${coords.longitude.toFixed(6)}°` : '0°';
  const latitude = coords.latitude ? `${coords.latitude.toFixed(6)}°` : '0°';
  const altitude = coords.altitude ? `${coords.altitude} m` : '0 m';
  const direction = coords.direction ? `${coords.direction}°` : '0°';
  const speed = coords.speed ? `${coords.speed} km/h` : '0 km/h';
  const date = coords.date
    ? new Date(coords.date).toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      })
    : '00/00/0000 00:00:00';

  // IDs únicos para cada botón
  const ids = {
    pos: `${id}-pos-event`,
    alt: `${id}-alt-event`,
    dir: `${id}-dir-event`,
    speed: `${id}-speed-event`,
    date: `${id}-date-event`,
    reference: `${id}-reference-event`,
    driver: `${id}-driver-event`,
    viewFull: `${coords.id}`,
  };

  // Formatear el número de evento con ceros a la izquierda (5 dígitos)
  const eventNumber = eventIndex.toString().padStart(5, '0');

  // Header tipo chip
  const header = `
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
      <div style="flex:1; display:flex; justify-content:center;">
        <span style="background:#fff3e0; color:#f57c00; font-weight:600; border-radius:12px; padding:4px 18px; font-size:13px; letter-spacing:1px; box-shadow:0 1px 4px #0001;">EVENTO ${eventNumber}</span>
      </div>
    </div>
  `;

  const popup = `
    ${header}
    <div id="${id}" style="font-family: 'Inter', Arial, sans-serif; font-size: 13px; color: #222;">
      
      <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 700; font-size: 14px; color: #333;">${
          coords.nameEvent
        }</span>
      </div>
      
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Referencia:</span>
        <span style="min-width: 170px; max-width: 170px;" id="${
          ids.reference
        }-content">
          ${
            coords.reference
              ? coords.reference
              : 'Buscando dirección ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ...... ......'
          }
        </span>
        <span id="${
          ids.reference
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>

      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Conductor:</span>
        <span style="min-width: 170px; max-width: 170px;" id="${
          ids.driver
        }-content">
          ${coords.nameDriver ? coords.nameDriver : 'Desconocido'}
        </span>
        <span id="${
          ids.driver
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
          
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Posición:</span>
        <span id="${
          ids.pos
        }-content" style="min-width: 170px; color: #1976d2; text-decoration: underline; cursor: pointer;" onclick="window.open('${urlGoogleMaps}', '_blank')">${latitude}, ${longitude}</span>
        <span id="${
          ids.pos
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      
      ${
        altitude
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Altitud:</span>
          <span style="min-width: 170px;" id="${ids.alt}-content">${altitude}</span>
          <span id="${ids.alt}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        direction
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Ángulo:</span>
          <span style="min-width: 170px;" id="${ids.dir}-content">${direction}</span>
          <span id="${ids.dir}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        speed
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Velocidad:</span>
          <span style="min-width: 170px;" id="${ids.speed}-content">${speed}</span>
          <span id="${ids.speed}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        date
          ? `
        <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; max-width: 100px; min-width: 100px; width: 100%">Fecha:</span>
          <span style="min-width: 170px;" id="${ids.date}-content">${date}</span>
          <span id="${ids.date}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      
      <div style="margin-top: 16px; padding-top: 16px; border-top: 1px solid #e0e0e0;">
        <button id="${
          ids.viewFull
        }" class="btn btn-sm btn-primary" style="width: 100%;">
          <i class="fas fa-external-link-alt"></i> Vista completa
        </button>
      </div>
    </div>
  `;

  // Devuelve el HTML y los valores a copiar para el listener externo
  return {
    html: popup,
    ids,
    values: {
      pos: `${coords.latitude},${coords.longitude}`,
      alt: coords.altitude?.toString() ?? '',
      dir: coords.direction?.toString() ?? '',
      speed: coords.speed?.toString() ?? '',
      date: date ?? '',
      reference: coords.reference ?? '',
      driver: coords.nameDriver ?? '',
    },
  };
};

export function adaptEventToPopupEvent(event: EventData): PopupEvent {
  return {
    id: event.customId ?? '',
    nameDriver: event.name_driver ?? 'Desconocido',
    latitude: parseFloat(event.latitud),
    longitude: parseFloat(event.longitud),
    altitude: parseFloat(event.altitud),
    direction: parseFloat(event.angulo),
    speed: parseFloat(event.velocidad),
    date: new Date(event.fecha_tracker),
    reference: event.referencia ?? undefined,
    nameEvent: event.name ?? event.nombre ?? event.mensaje_alerta,
    isEvaluated: event.evaluated === 1,
  };
}
